export interface RegistrationConfirmationRequest {
  regCode?: string | null;
  userEmail?: string | null;
  password?: string | null;
}

export const defaultValue: Readonly<RegistrationConfirmationRequest> = {};